import { Component, useEffect, useId, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { addNote, getNotes } from "../../services/Application";
import CardHeader from "./CardHeader";
import LoadingSpinner from "./LoadingSpinner";


import logger from "../../utils/logger";
/**
 * Komponent panelu z notatkami wewnętrznymi.
 *
 * @component
 * @param {Object} caseData  - Dane sprawy, do której notatki są przypisane.
 * @returns {Component} - Komponent panel z notatkami oraz formularz do dodawania nowych notatek.
 */
function NotesPanel({ caseData }) {
  const { accessToken, userId } = useAuth();

  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [newNoteText, setNewNoteText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchNotes = async () => {
      setIsLoading(true);
      try {
        const response = await getNotes(caseData.id, userId, accessToken);
        setNotes(response || []);
      } catch (error) {
        logger.error("Błąd pobierania notatek:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (caseData && userId && accessToken) {
      fetchNotes();
    }
  }, [caseData.id, userId, accessToken]);

  /**
   * Obsługuje dodanie nowej notatki.
   *
   * @function
   * @returns {void}
   */
  const handleAddNote = async () => {
    if (!newNoteText.trim()) {
      return;
    }

    setIsSubmitting(true);
    try {
      const note = await addNote(caseData.id, userId, newNoteText, accessToken);
      if (note) {
        setNotes((prevNotes) => [...prevNotes, note]);
        setNewNoteText("");
      }
    } catch (error) {
      logger.error("Błąd dodawania notatki:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <CardHeader text={"Notatki wewnętrzne"} onlyText="true" />
      <div className="card container-fluid shadow ms-4 px-4 py-3 w55">
        {isLoading ? (
          <div>
            <LoadingSpinner />
          </div>
        ) : (
          <div className="notes-panel d-flex flex-column w47">
            {notes.length === 0 ? (
              <div className="">Brak notatek</div>
            ) : (
              notes.map((note) => (
                <div
                  key={note.id}
                  className="note-item mb-3 p-1 border rounded"
                >
                  <div className="note-meta mb-1 d-flex align-items-center gap-2">
                    <small className="text-secondary">
                      {new Date(note.date).toLocaleString("pl-PL")}
                    </small>
                    {note.username && (
                      <small>
                        <b>{note.username}</b>
                      </small>
                    )}
                  </div>
                  <div className="note-text">{note.text}</div>
                </div>
              ))
            )}

            <div className="add-note">
              <textarea
                className="form-control mb-2"
                style={{ backgroundColor: "white" }}
                rows={3}
                placeholder="Napisz nową notatkę"
                value={newNoteText}
                onChange={(e) => setNewNoteText(e.target.value)}
                disabled={isSubmitting}
              />
              <button
                className="btn btn-primary"
                onClick={handleAddNote}
                disabled={isSubmitting || !newNoteText.trim()}
              >
                {isSubmitting ? "Dodawanie..." : "Dodaj notatkę"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NotesPanel;


